module.exports = __webpack_public_path__ + "assets/img/warrior-name-a65d7187.png";